import { Link } from 'react-router-dom';
import './Legal.css';

function TermsClient() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="back-button">
            <span className="back-arrow">←</span>
            Retour
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <h1 className="legal-title">Conditions Générales d'Utilisation</h1>
        <p className="legal-update">Dernière mise à jour : Décembre 2024</p>

        <div className="legal-tabs">
          <Link to="/terms" className="legal-tab active">Clients</Link>
          <Link to="/terms-pro" className="legal-tab">Chauffeurs Pro</Link>
        </div>

        <p className="legal-intro">
          Bienvenue sur RideLuv. Les présentes Conditions Générales d'Utilisation (« CGU ») régissent votre accès et utilisation de l'application mobile RideLuv. En créant un compte, vous acceptez d'être lié par ces conditions.
        </p>

        <section className="legal-section">
          <h2 className="legal-section-title">1. Définitions</h2>
          <p className="legal-section-text">
            « Application » désigne l'application mobile RideLuv. « Utilisateur » ou « Passager » désigne toute personne physique utilisant l'Application pour réserver une course. « Chauffeur Partenaire » désigne un chauffeur professionnel VTC indépendant utilisant RideLuv Pro. « Course » désigne le service de transport commandé via l'Application. « Service » désigne l'ensemble des fonctionnalités proposées par RideLuv.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">2. Objet du service</h2>
          <p className="legal-section-text">
            RideLuv est une plateforme de mise en relation entre des passagers et des chauffeurs VTC professionnels indépendants. RideLuv n'est pas une entreprise de transport mais un intermédiaire technologique facilitant la réservation de courses. Les chauffeurs sont des professionnels indépendants, titulaires de leur propre licence VTC.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">3. Inscription et compte</h2>
          <p className="legal-section-text">
            Pour utiliser RideLuv, vous devez créer un compte en fournissant des informations exactes et complètes. Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités effectuées depuis votre compte. Vous devez avoir au moins 18 ans pour créer un compte. RideLuv se réserve le droit de suspendre ou supprimer tout compte en cas de violation des présentes CGU.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">4. Réservation et courses</h2>
          <p className="legal-section-text">
            Les courses sont réservées via l'Application. Le prix estimé est communiqué avant confirmation et peut varier en fonction du trajet réel, du trafic et des conditions. En confirmant une course, vous vous engagez à honorer la réservation. Les annulations répétées peuvent entraîner des restrictions sur votre compte. Le chauffeur peut refuser une course si les conditions de sécurité ne sont pas réunies.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">5. Tarification et paiement</h2>
          <p className="legal-section-text">
            Les tarifs sont calculés selon la distance, la durée estimée et la demande. Le paiement s'effectue via les moyens de paiement enregistrés dans l'Application. Une facture électronique est disponible après chaque course. En cas de dommages causés au véhicule (salissures, dégradations), des frais supplémentaires peuvent être facturés. Les pourboires sont optionnels et intégralement reversés au chauffeur.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">6. Comportement des utilisateurs</h2>
          <p className="legal-section-text">
            Vous vous engagez à : respecter le chauffeur et son véhicule, ne pas fumer ni consommer d'alcool à bord, ne pas transporter de substances illicites, respecter le nombre de passagers autorisé, attacher votre ceinture de sécurité. Tout comportement inapproprié pourra entraîner la suspension immédiate de votre compte et des poursuites judiciaires le cas échéant.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">7. Responsabilités</h2>
          <p className="legal-section-text">
            RideLuv agit en qualité d'intermédiaire et n'est pas responsable de l'exécution du transport, qui relève de la responsabilité du chauffeur partenaire. RideLuv ne saurait être tenue responsable des retards, annulations par le chauffeur, ou incidents survenant pendant la course, sauf disposition légale contraire. Les chauffeurs partenaires disposent de leur propre assurance responsabilité civile professionnelle.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">8. Propriété intellectuelle</h2>
          <p className="legal-section-text">
            L'Application, son contenu, son design, ses logos et marques sont la propriété exclusive de RideLuv et sont protégés par les lois sur la propriété intellectuelle. Toute reproduction, modification ou utilisation non autorisée est strictement interdite et pourra faire l'objet de poursuites.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">9. Modification des CGU</h2>
          <p className="legal-section-text">
            RideLuv se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des modifications substantielles par notification dans l'Application. La poursuite de l'utilisation du Service après modification vaut acceptation des nouvelles conditions.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">10. Droit applicable</h2>
          <p className="legal-section-text">
            Les présentes CGU sont régies par le droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents. Pour toute réclamation, contactez-nous à support@rideluv.com.
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p className="legal-footer-text">
          Une question ? Contactez-nous à <a href="mailto:support@rideluv.com" className="legal-footer-link">support@rideluv.com</a>
        </p>
      </footer>
    </div>
  );
}

export default TermsClient;
